import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, forwardRef, Provider, EventEmitter } from '@angular/core';
import { UtilService } from '../../shared/util/util.service';
import { NameValue } from '../../shared/model/name-value.model';
import { AffCodeService } from '../shared/affcode.service';
import { AffCode } from '../shared/affcode.model';
import { AffCodeType } from '../shared/affcode-type.model';
import { TranslateService } from '@ngx-translate/core';
import { ProfileAdvancedSearchParams } from 'src/app/profiles/search/profile-advanced-search-params.model';

@Component({
  selector: 'wl-affcode-mass-add',
  templateUrl: 'affcode-mass-add.component.html',
  standalone: false
})
export class AffCodeMassAddComponent implements OnInit {
  @Input() public showButtons = true;
  @Input() public hideTypes = false;
  public _affCodeService: AffCodeService;
  public _utilService: UtilService;
  public _translateService: TranslateService;

  public selectedAffCodeTypeId: number;
  public selectedAffCodeId: number;
  public selectedAffCode: string;
  public affCodeTypes: Array<AffCodeType>;
  public affCodes: Array<AffCode>;
  public selectedProfileIds: Array<number>;

  public _noneText: string;

  public constructor(translateService: TranslateService, affCodeService: AffCodeService, utilService: UtilService) {
    this._affCodeService = affCodeService;
    this._utilService = utilService;
    this._translateService = translateService;

    this.selectedAffCodeTypeId = 0;
    this.selectedAffCodeId = 0;
    this.selectedAffCode = '';
    this.affCodeTypes = new Array<AffCodeType>();
    this.affCodes = new Array<AffCode>();
    this.selectedProfileIds = new Array<number>();

    this._noneText = '';
  }

  ngOnInit() {
    if (this.hideTypes) {
      this._affCodeService.getAllAffCodes().then((data) => {
        this.affCodes = data;
      });
    } else {
      this._affCodeService.getUserDefinedAffCodeTypesAndAffCodes().then((data: Array<AffCodeType>) => {
        this.affCodeTypes = data;
        if (this.affCodeTypes.length > 0) {
          if (this.affCodeTypes[0].AffCodes.length > 0) {
            this.selectedAffCode = this.affCodeTypes[0].AffCodes[0].AffCode;
          }
        }
      });
    }
  }

  affCodeTypesAddNone(data: Array<AffCodeType>) {
    const noneItem: AffCodeType = new AffCodeType();
    noneItem.AffCodeType = '';

    return this._translateService
      .get('common.none')
      .toPromise()
      .then((result: string) => {
        this._noneText = this._utilService.toTitleCase(result);
        noneItem.AffCodeType = this._noneText;
        this.affCodeTypes.splice(0, 0, noneItem);
        return Promise.resolve(this.affCodeTypes);
      });
  }

  affCodesAddNone(data: Array<AffCode>) {
    const noneItem: AffCode = new AffCode();
    noneItem.AffCode = '';

    return this._translateService
      .get('common.none')
      .toPromise()
      .then((result: string) => {
        this._noneText = this._utilService.toTitleCase(result);
        noneItem.AffCode = this._noneText;
        this.affCodes.splice(0, 0, noneItem);
        return Promise.resolve(this.affCodes);
      });
  }

  public setProfileIds(profileIds: Array<number>) {
    this.selectedProfileIds = profileIds;
  }

  public onAffCodeTypeChange(data: string) {
    // the option comes thru as a string convert to int
    this.selectedAffCodeTypeId = parseInt(data);
    for (const affCodeType of this.affCodeTypes) {
      if (affCodeType.AffCodeTypeID == this.selectedAffCodeTypeId) {
        this.affCodes = affCodeType.AffCodes;
      }
    }

    // added check or the code will add a "None" aff code to the array everytime you select the same aff type

    let hasNoneAffCode = false;

    for (const affCode of this.affCodes) {
      if (affCode.AffCode == this._noneText) {
        hasNoneAffCode = true;
      }
    }

    if (hasNoneAffCode == false) {
      this.affCodesAddNone(this.affCodes).then((data: Array<AffCode>) => {
        this.affCodes = data;
        this.selectedAffCode = this.affCodes[0].AffCode;
      });
    } else {
      this.selectedAffCode = this.affCodes[0].AffCode;
    }
  }

  public onAffCodeChange(data: string) {
    this.selectedAffCode = data;
    for (let affcode of this.affCodes) {
      if (affcode.AffCode == data) {
        this.selectedAffCodeId = affcode.AffId;
      }
    }
  }

  public addAffCodes() {
    this._affCodeService.addAffCodeToProfiles(this.selectedAffCode, this.selectedProfileIds);
  }

  removeAffCodes() {
    this._affCodeService.removeAffCodeFromProfiles(this.selectedAffCode, this.selectedProfileIds);
  }

  public cancel() {}

  addAffCodesAdvanced(searchParams: ProfileAdvancedSearchParams) {
    this._affCodeService.massAddAffCodeToProfiles(this.selectedAffCodeId, searchParams);
  }

  removeAffCodesAdvanced(searchParams: ProfileAdvancedSearchParams) {
    this._affCodeService.massRemoveAffCodeFromProfiles(this.selectedAffCodeId, searchParams);
  }
}
